import { Tag } from 'antd';
import React from 'react';
import ResponseCard from './ResponseCard/ResponseCard';
import { getColorClass, renderResponse } from '../../../utils/apiRenderingUtils';

const ResponseSection = (props) => {
  const { data, responseCode, setResponseCode, spec } = props;
  const codes = Object?.keys(data ?? {});
  if (!codes?.length) {
    return;
  }
  const response = data?.[responseCode] ?? data?.['default'] ?? data?.['200'];
  const responseExample = renderResponse(response, spec);

  return (
    <div className="response-section">
      <div className="response-header">
        <h3 className="section-heading">Response</h3>
        <div className="response-tags-container">
          {codes.map((code) => (
            <Tag
              key={code}
              className={`response-tag ${getColorClass(code)} ${responseCode === code ? 'active' : ''}`}
              onClick={() => setResponseCode(code)}
            >
              {code}
            </Tag>
          ))}
          <span className="content-type">application/json</span>
        </div>
      </div>

      <ResponseCard response={responseExample} />
    </div>
  );
};

export default ResponseSection;
